import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Header from "../../Header/Header";
import TenpoCheckTemplateModalButton from "./TenpoCheckTemplateModalButton";
import { Redirect } from "react-router-dom";
import { isOpenTemplatePage } from "../../../apis/privilege";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import {
  checkAuthUser,
  checkOperationCount,
  eventListeners,
  DAY_TIMER_SECOND,
  HOUR_TIMER_SECOND,
  HOUR_TIMER_MILL_SECOND,
} from "../../../apis/util";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: "100vh",
    },
    gridMargin: {
      padding: "1%",
    },
  })
);

const TemplateRegist: React.FC = (props: any) => {
  const classes = useStyles();
  const user = useSelector(selectUser);
  const [count, setCount] = React.useState(DAY_TIMER_SECOND);

  useEffect(() => {
    let userInfo = user;
    checkAuthUser(userInfo);
    // 画面操作時にタイマーをリセットするイベントを設定
    eventListeners.forEach((event) => {
      document.addEventListener(event, () => {
        setCount(DAY_TIMER_SECOND);
      });
    });
  }, []);

  // 1時間ごとに操作の有無をチェックし、24時間操作がなければログアウトする
  useEffect(() => {
    if (!checkOperationCount(count)) {
      return;
    }
    const interval = setInterval(() => {
      setCount(count - HOUR_TIMER_SECOND);
    }, HOUR_TIMER_MILL_SECOND);
    return () => clearInterval(interval);
  }, [count]);

  if (!isOpenTemplatePage(user)) {
    return <Redirect to="/home" />;
  }

  return (
    <Grid container className={classes.root} justify="center">
      <Grid item xs={12}>
        <Header titleName={"店舗確認表テンプレート"} />
        <Grid item xs={12} className={classes.gridMargin}>
          <TenpoCheckTemplateModalButton />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TemplateRegist;
